import React, { Component } from 'react';
import People from '../../static/img/people.svg'
import Barchart from '../barchart';
import style from '../../style/style';
import Loading from '../loading';

class Residents extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.data) return (<Loading fill={style.colors.primary} height="32px" width="32px" container={true} />);
    const data = { ...this.props };

    return (
      <div 
        style={{ ...style.fact.layout }}
      > 
        <div style={{ ...style.fact.left }}>
          <img src={People} style={{ width: style.fact.left.width, padding: style.padding, fill: style.colors.primary }} />
        </div>
        <div style={{ ...style.fact.right }}>
          <h2 style={{ ...style.fact.heading }}>
            { `${data.data.T8_1_TT} people live here` }
          </h2> 
          <Barchart
              data={ data.data }
              verb="are"
              fields={[
                { "name": "working", "value": "T8_1_WT" },
                { "name": "unemployed", "value": "T8_1_ULGUPJT" },
                { "name": "looking for 1st job", "value": "T8_1_LFFJT" },
                { "name": "students", "value": "T8_1_ST" },
                { "name": "homemakers", "value": "T8_1_LAHFT" },
                { "name": "retired", "value": "T8_1_RT" },
                { "name": "unable to work", "value": "T8_1_UTWSDT" },
                { "name": "other", "value": "T8_1_OTHT" }
              ]}
              total={ "T8_1_TT" }
            />
            <div style={{ ...style.fact.source }}>Source: Census 2016, <a href="http://www.cso.ie/">cso.ie</a>.</div>
        </div>
      </div>);
  }
}

export default Residents;



// WEBPACK FOOTER //
// ./src/components/residents/index.js